import React, { useContext, useEffect, useRef } from 'react';
import {
  Grid, makeStyles, Box, Typography, Button,
} from '@material-ui/core';
import {
  Home,
} from '@material-ui/icons';
import { Alert, AlertTitle } from '@material-ui/lab';
import { FormattedMessage, useIntl } from 'react-intl';
import StepperBooking from './Layout/StepperBooking';
import { maxWidth } from '../config/config';
import SelectedTimeSlotDetails from './Common/SelectedTimeSlotDetails';
import AppContext from '../state/AppContext';

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(11),
  },
  wrapperContent: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  inner: {
    paddingTop: theme.spacing(6),
    maxWidth: maxWidth + theme.spacing(2),
  },
}));

const ScreenConfirmation = () => {
  const intl = useIntl();
  const {
    appointmentDeletionFailed,
    appointmentToModify,
    isFollowUp,
  } = useContext(AppContext);

  const classes = useStyles();

  const containerElem = useRef(null);

  const gaTag = () => {
    if (isFollowUp) {
      return 'Follow-up Booked';
    }
    if (appointmentToModify) {
      return 'Appointment Modified';
    }
    return 'Evaluation Booked';
  };

  useEffect(() => {
    if (window && window.gtag) {
      window.gtag('event', 'select_content', {
        content_name: gaTag(),
        content_lang: intl.locale,
      });
    }

    if (containerElem) {
      containerElem.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }
  }, []);

  return (
    <div className={classes.container} ref={containerElem}>
      <StepperBooking activeStep={3} />
      <div className={classes.wrapperContent}>
        <Grid
          container
          spacing={2}
          justifyContent="center"
          style={{ minHeight: '100vh' }}
        >
          <Grid
            className={classes.inner}
            item
            xs={12}
          >
            <Box mb={6} mt={8}>
              <Alert severity="success">
                <AlertTitle>
                  <Typography variant="h5">
                    <strong>
                      <FormattedMessage
                        id={`ScreenConfirmation.alertTitle${appointmentToModify ? 'Modification' : ''}`}
                      />
                    </strong>
                  </Typography>
                </AlertTitle>

                <Typography variant="body1">
                  <FormattedMessage id="ScreenConfirmation.alertSubtitle" />
                </Typography>
              </Alert>
              {appointmentDeletionFailed && (
                <Alert severity="error">
                  <Typography variant="body1">
                    <FormattedMessage id="ScreenConfirmation.oldAppointmentNotCanceled" />
                  </Typography>
                </Alert>
              )}
            </Box>
            <SelectedTimeSlotDetails />

            <Box mb={6} mt={4}>
              <Button
                variant="contained"
                color="primary"
                // className={classes.button}
                startIcon={<Home />}
                onClick={() => {
                  window.location.reload();
                }}
              >
                <FormattedMessage id="ScreenConfirmation.btnBackHome" />
              </Button>
            </Box>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

ScreenConfirmation.propTypes = {};

export default ScreenConfirmation;
